<template>
  <div>
    <profile-header></profile-header>
  </div>
</template>
<script>
import ProfileHeader from "@/views/Components/Customer/ProfileHeader";

export default {
  components: {
    ProfileHeader,
  },
  props: {},
  data() {
    return {};
  },
};
</script>
